<template>
    <Modal :visible="showToast" :showFooter="false" :showHead="false" :closeAble="false" :prefixCls="prefixCls" :zIndex="zIndex">
        <div v-html="content" />
    </Modal>
</template>
<script>
import Modal from "./Modal";
export default {
    name: "Toast",
    components: {
        Modal
    },
    data( ) {
        return {
            content: "我是toast",
            showToast: false
        }
    },
    props: {
        prefixCls: {
            type: String,
            default: "tm-toast"
        },
        visible: {
            type: Boolean,
            default: false
        },
        zIndex: {
            type: Number,
            default: 10000
        }
    },
    beforeMount( ) {
        this.showToast = this.visible;
    },
    methods: {
        setContent( content ) {
            this.content = content;
        },
        show( ) {
            this.showToast = true;
        },
        close( ) {
            this.showToast = false;
        }
    }
};
</script>
<style lang="less">
@prefixCls: .tm-toast;

@{prefixCls}-wrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

}

@{prefixCls}-mask {
    background: #000;
    background: rgba(0, 0, 0, 0.3);
    filter: alpha(opacity=30);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

@{prefixCls}-content {
    width: 280px;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 8px;
}

@{prefixCls}-header {
    position: relative;
}

@{prefixCls}-header-inner {
    height: 56px;
    font-size: 16px;
    line-height: 56px;
    color: #333333;
    text-align: center;
}

@{prefixCls}-close {
    position: absolute;
    outline: none;
    text-decoration: none;
    right: 12px;
    top: 12px;
    padding: 8px;
    z-index: 100;
}

@{prefixCls}-icon-close {
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("../../assets/images/components/modal/icon_delete.png") center center no-repeat;
    background-size: 12px 12px;
}

@{prefixCls}-body {
    font-size: 14px;
    line-height: 24px;
    color: #888888;
    padding: 16px 20px;
    text-align: center;
}

@{prefixCls}-footer {}

@{prefixCls}-footer-content {
    display: flex;
    flex-direction: row;
}

@{prefixCls}-btn-cancel {
    flex: 1;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    color: #AAAAAA;
    text-decoration: none;
    text-align: center;
    border-top: 1px solid #EBEBEB;
    border-right: 1px solid #EBEBEB;
}

@{prefixCls}-btn-confirm {
    flex: 1;
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    color: #C0A266;
    text-decoration: none;
    text-align: center;
    border-top: 1px solid #EBEBEB;
}
</style>